import { render } from "./Content.vue?vue&type=template&id=02295bdf&scoped=true"
const script = {}

import "./Content.vue?vue&type=style&index=0&id=02295bdf&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-02295bdf"]])

export default __exports__